import React from "react";
import PropTypes from "prop-types";
import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withApplicationFeatures } from "providers/ApplicationFeaturesConsumer";
import DecisionSummaryContainer from "../../../../features/document/edit/decision/summary/components/DecisionSummaryContainer";
import ApprovalLevelsContainer from "../../../../features/document/edit/decision/approvalLevels/components/ApprovalLevelsContainer";
import OfferDecisionFinancedAssetsContainer from "./OfferDecisionFinancedAssetsContainer";
import OfferDecisionFinancedAssetsChartContainer from "./OfferDecisionFinancedAssetsChartContainer";
import OfferDecisionConditionContainer from "./OfferDecisionConditionContainer";
import OfferDecisionSubsequentConditionContainer from "./OfferDecisionSubsequentConditionContainer";
import { withRights } from "providers/RightsConsumer";

class OfferDecisionComponent extends React.PureComponent {
  render() {
    const { documentId, siteId, rights, applicationFeatures } = this.props;

    return (
      <>
        {rights.decisionSummaryRead && <DecisionSummaryContainer documentId={documentId} siteId={siteId} />}
        {rights.decisionApprovalLevelRead && <ApprovalLevelsContainer documentId={documentId} siteId={siteId} />}
        <OfferDecisionFinancedAssetsContainer documentId={documentId} siteId={siteId} />
        {applicationFeatures.offerWithFinancedChart && <OfferDecisionFinancedAssetsChartContainer documentId={documentId} siteId={siteId} />}
        {rights.decisionConditionsRead && <OfferDecisionConditionContainer documentId={documentId} siteId={siteId} />}
        {rights.decisionSubsequentConditionsRead && (
          <OfferDecisionSubsequentConditionContainer documentId={documentId} siteId={siteId} />
        )}
      </>
    );
  }
}

OfferDecisionComponent.propTypes = {
  actions: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  applicationFeatures: PropTypes.object,
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  rights: PropTypes.object.isRequired
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({}, dispatch),
    dispatch
  };
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation(),
  withApplicationFeatures
)(withRights(OfferDecisionComponent));
